/** @jsxImportSource @emotion/react */
import React from "react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Spinner } from "../../../Spinner/Spinner";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../../../../config/consts";
import { ReactComponent as ViewTransactionIcon } from "../../../../img/trade-interface/view_transaction_white.svg";
import { css } from "@emotion/react";
import { approvalSpinnerWrapper } from "../../../../config/commonCSS";

export const ProcessingTransaction: React.FC<{ tx: string; isVisible: boolean }> = ({
  isVisible,
  tx,
}) => {
  const network = GlobalStore.useState(s => s.network);
  if (!isVisible) {
    return null;
  }
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        justify-content: end;
      `}
    >
      <div css={approvalSpinnerWrapper}>
        <Spinner />
      </div>
      <span className="ms-1" css={css``}>
        Processing
      </span>
      <a
        className="approval-many-btn text-white"
        href={`${BLOCK_EXPLORER_URL_BY_NETWORK[network.id]}tx/${tx}`}
        target="_blank"
        rel="noreferrer"
        style={{ marginLeft: "10px" }}
      >
        <ViewTransactionIcon style={{ width: "18px", height: "18px" }} />
        <span className="ms-1">View Transaction</span>
      </a>
    </div>
  );
};
